<template lang="pug">
index-page(
  @set-loading="setLoading",
  :parentData="{ grid, path, grid_key, report_class, report_namespace, headerSearchClass: 'col-11 no-padding', headerFiltersContainerClass: 'col-1' }"
)
</template>

<script>
import indexPage from "../../../shared/indexPage";

export default {
  components: {
    indexPage,
  },
  data: function () {
    return {
      grid: "measuring_meter_types",
      report_class: "meter_type",
      report_namespace: "measuring",
      path: this.$store.state.paths["measuring_meter_type"],
      grid_key: "data",
    };
  },

  beforeMount() {
    // this.$emit('set-loading', false)
    this.$emit("expand-class", { val: false, class: "" });
  },

  methods: {
    setLoading(val) {
      this.$emit("set-loading", val);
    },
  },
};
</script>

<style lang="scss"></style>
